<h1 *ngIf="!overviewData" class="px-2 mx-auto">Loading...</h1>
<section
  *ngIf="overviewData"
  class="container flex justify-center w-full px-2 mx-auto"
>
  <table class="border-separate table-auto">
    <thead class="">
      <tr class="">
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Entity
        </th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Count
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of getTableRows()">
        <td class="px-2 bg-gray-800 border border-gray-800 border-solid">
          {{ row.entity }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ row.count }}
        </td>
      </tr>
    </tbody>
  </table>
</section>
